//@ts-check
// Store common data such as drop-down list data
import { getTimezones } from "../../utils/timezones";

import {
    commonConstants,
    settingConstants
    //  AccountConstants
} from '../../constants/constants';
import { getfetchopts } from "utils/fetchutils";
import { logout } from "utils/store";
import axios from "axios";

const getDeviceModels = (id) => {
    return async (dispatch) => {
      try {
        const config = getfetchopts({
          method: "GET",
          url: "/api/devicemgt/models",
        });
        //@ts-ignore
        const response = await axios(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

        const data = response.data;
        dispatch({
          type: commonConstants.GET_COMMON_DEVICE_MODELS,
          payload: data,
        });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          logout();
        } else {
          throw error;
        }
      }
    };
};

const getDeviceVersityVersionss = (id) => {
    return async (dispatch) => {
      try {
        const config = getfetchopts({
          method: "GET",
          url: "/api/devicemgt/versity-versions",
        });

        //@ts-ignore
        const response = await axios(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

        const data = response.data;
        dispatch({
          type: commonConstants.GET_COMMON_DEVICE_VERSITY_VERSIONS,
          payload: data,
        });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          logout();
        } else {
          throw error;
        }
      }
    };
};

const getAlertTypes = id => {
    return async dispatch => {
      try {
        const config = getfetchopts({
          method: 'GET',
          url: '/api/notifications/alert-types'
        });
        const result = await axios.request(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
        dispatch({
          type: commonConstants.GET_COMMON_ALERT_TYPES,
          payload: result.data
        })
      } catch (e) {
        console.error('Error:', e);
        if (e.response && e.response.status === 401) {
          logout();
        }
        throw e;
      }
    };
};

const getLocations = id => {
    console.log('getLocations -> id', id)
    return async dispatch => {
        try {
            const config = getfetchopts({
                method: 'GET',
                url: '/api/locations/options'
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            const data = result.data;
            dispatch({ type: commonConstants.GET_COMMON_LOCATIONS, payload: data });
        } catch (e) {
            console.error('Error:', e);
            if (e.response && e.response.status === 401) {
                logout();
            }
            throw e;
        }
    };
};

const getOrganizations = () => {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/identity/orgs",
      });

      //@ts-ignore
      const response = await axios(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

      dispatch({
        type: commonConstants.GET_ORGANIZATIONS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error fetching organizations:", error);
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        throw error;
      }
    }
  };
};


const getSettingsList = id => {
    return async dispatch => {
        try {
            const config = getfetchopts({
                method: 'GET',
                url: `/api/core/setting/${id || 'none'}/list`
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            const data = result.data;
            if (data.result) {
                dispatch({
                    type: settingConstants.LOAD_SETTING_TABLE,
                    payload: data.settings
                });
            }
        } catch (e) {
            console.error('Error:', e);
            const status = e.response?.status;
            const authErrorCodes = [401];
            if (authErrorCodes.includes(status)) {
                logout();
            }
            throw e;
        }
    };
};

const getSSIDSByTenantId = (tenantid) => {
    return async dispatch => {
        try {
            const config = getfetchopts({
                method: 'GET',
                url: `/api/locations/ssids${tenantid ? `?tenant_id=${tenantid}` : ``}`
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            const data = result.data;
            dispatch({
                type: settingConstants.SSIDS,
                payload: data.ssids
            })
        } catch (e) {
            console.error('Error:', e);
            if (e.response && e.response.status === 401) {
                logout();
            }
            throw e;
        }
    }
}

const getRolegetOptions = () => {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/identity/roles",
      });

      //@ts-ignore
      const response = await axios(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

      dispatch({
        type: commonConstants.GET_ROLE_OPTIONS,
        payload: response.data,
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        throw error;
      }
    }
  };
};

const getLocationOptions = () => {
    return async dispatch => {
        try {
            const config = getfetchopts({
                method: 'GET',
                url: '/api/locations/options'
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            const data = result.data;
            dispatch({ type: commonConstants.GET_LOCATION_OPTIONS, payload: data });
        } catch (e) {
            console.error('Error:', e);
            if (e.response && e.response.status === 401) {
                logout();
            }
            throw e;
        }
    };
};

const getDeviceTags = () => {
    return async (dispatch) => {
      try {
        const config = getfetchopts({
          method: "GET",
          url: "/api/devicemgt/tags",
        });
        //@ts-ignore
        const response = await axios(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

        const data = response.data;
        dispatch({ type: commonConstants.GET_DEVICE_TAGS, payload: data });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          logout();
        } else {
          throw error;
        }
      }
    };
};

const getTimeZones = () => {
    return async dispatch => {
        const data = getTimezones();
        dispatch({
            type: commonConstants.GET_TIME_ZONE_OPTIONS,
            payload: data
        });
    };
};

const getAccountOptions = () => {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/identity/roles",
      });

      //@ts-ignore
      const response = await axios(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

      dispatch({
        type: commonConstants.GET_ACCOUNTS_OPTIONS,
        payload: response.data,
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        throw error;
      }
    }
  };
};

const getAccountOrganizations = (accountId) => {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/identity/orgs",
        params: { accountId },
      });

      //@ts-ignore
      const response = await axios(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, response);

      dispatch({
        type: commonConstants.GET_ACCOUNT_ORGANIZATIONS,
        payload: response.data,
        accountId,
      });
    } catch (error) {
      console.error("Error fetching account organizations:", error);
      if (error.response?.status === 401) {
        logout();
      } else {
        throw error;
      }
    }
  };
};

const getOrganizationLocationOptions = (accountId, organizationId) => {
    return async dispatch => {
        try {
            const config = getfetchopts({
                method: 'GET',
                url: `/api/locations/options?organizationId=${organizationId}`
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            const data = result.data;
            dispatch({
                type: commonConstants.GET_ORGANIZATION_OPTIONS,
                payload: data,
                accountId,
                organizationId
            });
        } catch (e) {
            console.error('Error:', e);
            if (e.response && e.response.status === 401) {
                logout();
            }
            throw e;
        }
    };
};

export default {
    getDeviceModels,
    getDeviceVersityVersionss,
    getAlertTypes,
    getLocations,
    getOrganizations,
    getSettingsList,
    getRolegetOptions,
    getLocationOptions,
    getDeviceTags,
    getTimeZones,
    getAccountOptions,
    getAccountOrganizations,
    getOrganizationLocationOptions,
    getSSIDSByTenantId
};
